import React from 'react';

import { ChevronIcon } from '@icons';

import { GAME_TYPE, type FilterGameType } from '@types';

import * as Styled from './calendar-header.styled';

type OwnProps = {
	months: string[];
	currentMonth: number;
	currentYear: number;
	filteredGameType: FilterGameType;
	onPrevMonth: () => void;
	onNextMonth: () => void;
	onFilterClick: (gameType: GAME_TYPE) => void;
};

const CalendarHeader: React.FC<OwnProps> = ({
	months,
	currentMonth,
	currentYear,
	filteredGameType,
	onPrevMonth,
	onNextMonth,
	onFilterClick
}) => {
	return (
		<Styled.Header>
			<Styled.EmptyDiv />

			<Styled.Month>
				<Styled.ArrowWrapper onClick={onPrevMonth}>
					<ChevronIcon />
				</Styled.ArrowWrapper>
				<Styled.MonthText>
					{months[currentMonth]} {currentYear}
				</Styled.MonthText>
				<Styled.ArrowWrapper onClick={onNextMonth}>
					<ChevronIcon.Right />
				</Styled.ArrowWrapper>
			</Styled.Month>

			<Styled.Filter>
				<Styled.FilterWrapper
					$active={filteredGameType === GAME_TYPE.DOTA2}
					onClick={() => onFilterClick(GAME_TYPE.DOTA2)}
				>
					Dota 2
				</Styled.FilterWrapper>
				<Styled.FilterWrapper
					$active={filteredGameType === GAME_TYPE.CS2}
					onClick={() => onFilterClick(GAME_TYPE.CS2)}
				>
					CS 2
				</Styled.FilterWrapper>
				<Styled.FilterWrapper
					$active={filteredGameType === GAME_TYPE.LOL}
					onClick={() => onFilterClick(GAME_TYPE.LOL)}
				>
					LoL
				</Styled.FilterWrapper>
			</Styled.Filter>
		</Styled.Header>
	);
};

export default CalendarHeader; 